import { useEffect, useState } from 'react';
import { onScrollScenesActivated, scrollScenesActivated } from '../../../shared/lib/scroll-scenes';

const INTENT_EVENTS = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'pointermove', 'keydown'] as const;

/**
 * Every animation on this page is scroll-driven, so none of it needs to exist
 * before the visitor moves. Building the ScrollTriggers up front costs a full
 * layout pass over a 13,000px document during load; waiting for the first sign
 * of interaction moves that off the critical path without the visitor ever
 * seeing a missing animation.
 */
export function useMotionReady(): boolean {
  const [ready, setReady] = useState(scrollScenesActivated);

  useEffect(() => {
    if (ready) {
      return;
    }

    const enable = () => setReady(true);

    // A visitor who is already scrolled in (reload, deep link) gets it at once.
    if (window.scrollY > 0) {
      enable();
      return;
    }

    const unsubscribe = onScrollScenesActivated(enable);

    INTENT_EVENTS.forEach((event) => {
      window.addEventListener(event, enable, { passive: true, once: true });
    });

    return () => {
      unsubscribe();
      INTENT_EVENTS.forEach((event) => window.removeEventListener(event, enable));
    };
  }, [ready]);

  return ready;
}
